const seoFlagEncoded = "&lt;!--friendly--&gt;";
const seoFlagDecoded = "<!--friendly-->";

export const isSeoFriendly = (headerHTML: string | undefined) => {
  if (!headerHTML) return false;

  return (
    headerHTML.startsWith(seoFlagEncoded) ||
    headerHTML.startsWith(seoFlagDecoded)
  );
};

export const removeSeoFlagDecoded = (str: string) =>
  str.replace(seoFlagEncoded, "").replace(seoFlagDecoded, "").trim();

export const removeHtmlTags = (string: string) =>
  string
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/(<([^>]+)>)/g, "")
    .trim();

export type CategoryTitle = {
  headerTitle: string | undefined;
  friendlyName: string;
  headerHtmlEncoded: string;
};

export const getHeaderTitle = ({
  headerTitle,
  friendlyName,
  headerHtmlEncoded,
}: CategoryTitle) =>
  headerTitle ||
  (isSeoFriendly(headerHtmlEncoded)
    ? removeHtmlTags(removeSeoFlagDecoded(headerHtmlEncoded))
    : friendlyName);
